module.exports = __webpack_public_path__ + "media/images/icon-club-6fe99b380e06297d23218e72e6938621.svg";